<template>
    <div class="favorite-page">
        <div class="container">
            <div class="page-title">
                <h1>{{favoritePage.page_title}}</h1>
            </div>
            <div class="page-title-navigation" ref="favoriteInNav">
                <ul ref="favoriteNavlist">
                    <li v-for="item in favoritePage.page_nav"><router-link :to="item.link == '/favorite' ? '/favorite' : item.href" @click.native="scrollIntoView">{{ item.name }}</router-link></li>
                </ul>
            </div>
            <router-view></router-view>
        </div>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import formPage from '@/components/forms/form-page.vue'
    export default {
        name: 'favorite--page',
        components: {
            formPage,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Избранное',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            favoritePage: 'loadFavoritePage',
        }),
        methods: {
            scrollIntoView() {
                const container = this.$refs.favoriteInNav;
                const list = this.$refs.favoriteNavlist;
                const activeElement = list.querySelector('.router-link-exact-active');
                if (container && list && activeElement) {
                    const containerRect = container.getBoundingClientRect();
                    const elementRect = activeElement.getBoundingClientRect();
                    const activeElementLeft = elementRect.left;
                    container.scrollLeft = activeElementLeft - 125;
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.favoritePage != null) {
                next(vm => {
                    vm.scrollIntoView();
                });
            } else {
                store.dispatch('getFavoritePageData').then((response) => {
                    if (response) {
                        next(vm => {
                            vm.scrollIntoView();
                        });
                    } else {
                        next(false);
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'favorite';
        },
        created () {
        },
        mounted() {
            this.scrollIntoView();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/favorite-page/favorite-page.scss';
    @import '@/styles/components/favorite-page/respond/favorite-page-respond.scss';
</style>